import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartService } from '../../../services/cart.service';
import { Product } from 'src/app/models/product.model';
import { WishlistService } from 'src/app/services/wishlist.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import * as moment from 'moment';


@Component({
  selector: 'app-cart-list',
  templateUrl: './cart-list.component.html',
  styleUrls: ['./cart-list.component.less'],
})
export class CartListComponent implements OnInit {
  @Input() sortType: string = "create_time/asc";
  @Input() form: any;
  @Input() productList: any = [];
  @Input() errorMessage:any[] = [];
  @Input() messages:any[] = [];
  @Input() placeErrorMessage:any[] = [];
  @Input() reSimulate: boolean = false;
  @Input() hasErrorMessage:boolean=false;
  @Input() isRequiredDateShouldBeLater:boolean=false;
  @Input() needSimulate:boolean=false;
  @Input() placeOrderEnable:boolean=false;
  @Output() itemSelectionChanged = new EventEmitter<any>(); // change select
  debounceTimer: any = null;
  isChanging:boolean = false; // quantity is changing
  showTips:boolean = true; // show tips above cart list
  showPlaceTips: boolean = true;
  country: string | null = localStorage.getItem('country');

  
  

  quantityBlur(newQuantity: number, item: any) {
    item.quantity = newQuantity;
    item.inputQuantity = newQuantity;
  }
  quantityChange(newQuantity: number, item: any) {
    sessionStorage.setItem('isUpdatingProduct','true');
    if(item.quantity==item.inputQuantity){
      return;
    }
    this.isChanging = true;
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      item.quantity = newQuantity;
      item.inputQuantity = newQuantity;
      this.isChanging = false;
      this.updateFromCart(item);
    }, 1000);
  }

  warningCategory: any = {
    product_warning:['007','008'],
    qty_warning: ['012','013'],
    discount_warning:['005','006','030','031','033','034','037','023'],
  };
  constructor(private commonService:CommonService,private cartService: CartService,private wishlistService:WishlistService,private message:NzMessageService,private translate:TranslateService) {}

  ngOnInit(): void {
  }

  getMessageByPromotion(messages: { code: string; message: string; severity: string }[], expectedDate: string, lastPickupDate: string): string[] {
    return messages
      .filter(msg => this.warningCategory.discount_warning.includes(msg.code))
      .map(msg => {
        if (lastPickupDate !== '' && lastPickupDate !== null) {
          return `需求日期早于 ${lastPickupDate} 且${msg.message}`;
        }
        return msg.message
      });
  }

  getIsBeforeLastPickupDate(expectedDate: string, lastPickupDate: string) {
    if (lastPickupDate !== '' && lastPickupDate !== null) {
      const formattedLastPickupDate = new Date(lastPickupDate);
      const formattedExpectedDate = new Date(expectedDate);
      if (formattedExpectedDate < formattedLastPickupDate) {
        return true;
      } else {
        return false;
      }
    }
    return true
  }

  getMessagesExcludingPromotion(messages: { code: string; message: string; severity: string }[]): { code: string; message: string; severity: string }[] {
    return messages
    .filter(msg => !this.warningCategory.discount_warning.includes(msg.code));
  }

  getPromptMessages(item: any): string[] {
    return Array.isArray(item?.promptMessages) ? item.promptMessages : [];
  }

  hasItemMessages(item: any): boolean {
    return this.getMessagesExcludingPromotion(item?.errorMessages ?? []).length > 0 || this.getPromptMessages(item).length > 0;
  }

  isOesCountry(): boolean {
    const currentCountry = (localStorage.getItem('country') || '').trim().toLowerCase();
    const componentCountry = (this.country || '').trim().toLowerCase();
    const pathName = window.location.pathname.toLowerCase();
    return [currentCountry, componentCountry].includes('/oes') ||
      [currentCountry, componentCountry].includes('oes') ||
      pathName.includes('/oes');
  }

  getMaxDeliveryDate(deliveryInfoList: any[]): string {
    if (!Array.isArray(deliveryInfoList) || deliveryInfoList.length === 0) {
      return '';
    }

    return deliveryInfoList
      .map(deliveryInfo => deliveryInfo?.deliveryDate)
      .filter(Boolean)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
      .pop() || '';
  }

  getDeliveryInfoListForDisplay(deliveryInfoList: any[]): any[] {
    if (!this.isOesCountry()) {
      return deliveryInfoList;
    }

    const maxDeliveryDate = this.getMaxDeliveryDate(deliveryInfoList);
    return maxDeliveryDate ? [{ deliveryDate: maxDeliveryDate }] : [];
  }

  shouldShowDeliveryQuantity(): boolean {
    return !this.isOesCountry();
  }
  
  
  

  toggleSelect(item: any) {
    item.isSelect = !item.isSelect;
    this.itemSelectionChanged.emit(item);
  }

  trackByFn(index: number, item: any): any {
    return item.id; 
  }

  onDatePickerChange(newDate: Date, item: Product): void {
    if (moment(newDate).format('YYYY-MM-DD')!== item.expectedDate) {
    item.expectedDate = this.commonService.formatDateString(newDate);
    this.cartService.updateCartItem(item);
    }
  }
  updateFromCart(product: Product): void {
    this.cartService.updateCartItem(product);
  }
  removeFromCart(productId: number): void {
    this.cartService.removeFromCart(this.form,productId);
  }
  disabledDate = (current: Date): boolean => {
    if (this.isAutoPlusSevenNeed()) {
      const targetDate = new Date();
      targetDate.setDate(targetDate.getDate() + 7);
      targetDate.setHours(0, 0, 0, 0);
      return current < targetDate; // disable the date before today
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return current < today; // disable the date before today
    }
  };

  isAutoPlusSevenNeed() {
    const storedCustomer = localStorage.getItem("customer");
    const customerInfo = storedCustomer ? JSON.parse(storedCustomer) : null;
    const salesOrg = this.getOrgCode();
    if (customerInfo !== null && salesOrg === 'CN20-G4-40') {
      return true;
    } else {
      return false;
    }
  }

  getOrgCode():string{
    
    const orgs = ["/iam", "/oes"];
    const router = orgs.find(org => window.location.pathname.includes(org));
    const orgMapping = JSON.parse(localStorage.getItem('allOrgRoutes') || '{}');
    const userOrg = JSON.parse(localStorage.getItem('sales_org') || '[]');
    const orgList = orgMapping[`${router}`];
    if(window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      return 'CN20-G1-40';
    } 
    if (!orgList || orgList.length === 0) {
      return ''; 
    }
    if (orgList.includes('CN20-G1-40') && userOrg.includes('CN20-G1-40')) {
      return 'CN20-G1-40';
    }
  
    const firstMatchingOrg = orgList.find((org:any) => userOrg.includes(org));
  
    return firstMatchingOrg ? firstMatchingOrg : orgList[0];
  }
  
  isInPromotion(item: any): boolean {
    return (
      item?.components?.length > 0 &&
      item.components.every((c: any) => c.isGift) &&
      item?.isSimulated
    );
  }
  //When determining if there are errors in the shopping cart, exclude cases like 013, as they have already been corrected during the preceding steps.
  checkError(errorMessages:any){
    return (errorMessages.length === 1 &&
      errorMessages[0].code === '013') ||
      errorMessages.length === 0
  }
  async moveToWhishList(item:any): Promise<void> {
    let params={
      "id": item.id,
      "quantity": item.quantity
    };
    await this.wishlistService.addToWhishList(params);
  }
    //get messages by type：warning or error
    getMessagesByType(errors:any[],type:string,category?:string):string[]{
      if(!Array.isArray(errors)){
        return [];
      }
      if(category){
        return errors.filter(error => {
            return this.warningCategory[category].includes(error.code);
        }).map(filteredError => {
            return filteredError.message;
        });
        }
      let filteredErrors = errors?.filter(error => error.severity === type);
      return filteredErrors?.map(error => error.message);
    }
}
